export const INACTIVITY_TIMEOUT_MS = 1000 * 60 * 10;
export const INACTIVITY_TIMEOUT_MS_FOR_DEVELOPMENT = 1000 * 60 * 60 * 24;
export const PROMPT_BEFORE_IDLE = 1000 * 60 * 5;
